/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.i = 2;
    }

    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }

    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      if (search) {
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }

    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }

    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }

    loadProducts() {
  let base = this;

  if (base.getAttribute('loading')) {
    return;
  }

  // Show spinner and disable button
  base.setAttribute('loading', true);
  base.button.disabled = true;
  const spinner = base.button.querySelector('.spinner');  // Adjust selector if needed
  if (spinner) spinner.style.display = 'inline-block';    // or your method to show spinner

  let url = base.button.getAttribute('data-next-url');
  if (!url) {
    url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
    base.i++;
  }

  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      base.renderProducts(responseText);

      // Update data-next-url or hide button if none
      const newDoc = new DOMParser().parseFromString(responseText, 'text/html');
      const newButton = newDoc.querySelector('.load-more');
      if (newButton && newButton.dataset.nextUrl) {
        base.button.setAttribute('data-next-url', newButton.dataset.nextUrl);
        
      } else {
        if (base.observer) base.observer.unobserve(base);
        if (base.button) base.button.classList.add('visually-hidden');
      }
    })
    .catch((err) => {
      console.error('Load more failed:', err);
    })
    .finally(() => {
      // Hide spinner and enable button again
      base.removeAttribute('loading');
      base.button.disabled = false;
      if (spinner) spinner.style.display = 'none';
    });
}


    renderProducts(html) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }

      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }

      gsap.set(products, {
        opacity: 0,
        y: 30
      });

      gsap.to(products, {
        duration: 0.5,
        y: 0,
        opacity: 1,
        stagger: 0.05,
        onComplete: function () {
          base.removeAttribute('loading');
        }
      });
    }
  }

  customElements.define('pagination-theme', Pagination);
}
